import { Modal, Button, Text } from "@mantine/core";

export interface IDeleteConfirmationDialogProps {
    show: boolean;
    title: string;
    message: string;
    onDeleteClick: () => void;
    onCancelClick: () => void;
    onHide: () => void;
}

export default function DeleteConfirmationDialog(props: IDeleteConfirmationDialogProps) {
    return (
        <Modal centered opened={props.show} onClose={props.onHide} title={<Text weight={700} color="red">{`${props.title}`}</Text>}>
            <p>{props.message}</p>
            <Button color="red" onClick={props.onDeleteClick}>Delete</Button>{' '}
            <Button color="gray" onClick={props.onCancelClick}>Cancel</Button>
        </Modal>
    );
}